import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftOutlookRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M29.244 16.822a.729.729 0 1 0 0-1.457.729.729 0 0 0 0 1.457m-19.664.034a.876.876 0 1 0 0-1.752.876.876 0 0 0 0 1.752",
			fill: "#123b6d"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.486 15.98h-10.2v.488l9.492 5.214.127.066a1.34 1.34 0 0 0 1.163 0l.127-.067 9.491-5.213v-.488zm0 0h-10.2v-.488l9.492-5.214.127-.067a1.34 1.34 0 0 1 1.163 0l.127.067 9.451 5.22v.482z",
			fill: "#123b6d"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.992 4.222H11.999a1.23 1.23 0 0 0-1.23 1.23V24.79c0 .679.551 1.23 1.23 1.23h14.993c.68 0 1.23-.551 1.23-1.23V5.452c0-.679-.55-1.23-1.23-1.23",
			fill: "#28a8ea"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.77 16.822h6.964v5.254H10.77z",
			fill: "#14447d"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.865 16.822h6.116v5.254h-6.116z",
			fill: "#0364b8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.77 11.762h6.096v5.06H10.77z",
			fill: "#0664b2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.982 16.822h5.247v5.254h-5.247zm-6.116-5.06h6.116v5.06h-6.116zM10.77 6.71h6.096v5.053H10.77z",
			fill: "#0078d4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.981 6.71h5.247v5.052h-5.247z",
			fill: "#50d9ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 4.223h14.972c.323 0 .634.124.869.347a1.17 1.17 0 0 1 .36.836v1.336H10.77V5.406A1.21 1.21 0 0 1 12 4.223",
			fill: "#0358a7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m29.686 16.468-9.492 5.207a1 1 0 0 1-.127.073 1.34 1.34 0 0 1-1.163 0 1 1 0 0 1-.127-.073L9.3 16.468a.56.56 0 0 1-.287-.488v10.514a1.283 1.283 0 0 0 1.337 1.263h18.314A1.28 1.28 0 0 0 30 26.494V15.98a.56.56 0 0 1-.287.488z",
			fill: "url(#paint0_linear_9758_1684)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M19.486 21.882c-.202 0-.4-.046-.582-.134l-9.558-5.247.427-.735s9.358 5.16 9.539 5.234a.47.47 0 0 0 .367 0l9.559-5.254.407.722-9.578 5.28a1.3 1.3 0 0 1-.581.134",
			fill: "#0a2767"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.308 27.778h18.355c.277-.001.547-.085.775-.241l-10.534-5.789a1 1 0 0 1-.127-.073L9.3 16.468l-.294-.16v10.186a1.283 1.283 0 0 0 1.303 1.284",
			fill: "#28a8ea"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .67,
			fill: "#000",
			children: [
				/* @__PURE__ */ _jsx("path", {
					opacity: .05,
					d: "M17.032 9.236H9.954a.4.4 0 0 0-.054.187v13.12a.44.44 0 0 0 .441.429h6.09a.863.863 0 0 0 .875-.85V9.845a.82.82 0 0 0-.274-.608"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M14.827 11.214H8.998v13.529h5.829a1.13 1.13 0 0 0 1.163-1.09V12.29a1.13 1.13 0 0 0-1.163-1.076"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M14.827 10.452H8.998v13.509h5.829a1.13 1.13 0 0 0 1.163-1.083V11.515a1.13 1.13 0 0 0-1.163-1.063"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M16.083 9.262h-6.09a.434.434 0 0 0-.44.421v13.128a.434.434 0 0 0 .44.421h6.09a.86.86 0 0 0 .862-.842V10.105a.86.86 0 0 0-.862-.843"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M16.07 9.61H9.981a.435.435 0 0 0-.441.421v12.994a.435.435 0 0 0 .441.421l6.016.1a1.04 1.04 0 0 0 .95-.942V10.452a.863.863 0 0 0-.876-.842"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .01,
					d: "M8.998 9.236v10.4h-.073v1.725a.43.43 0 0 0 .434.42l4.84-.855c.48 0 1.778-.4 1.778-.869V9.463a1 1 0 0 0-.047-.227z"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M14.827 10.806H8.998v13.53h5.829a1.13 1.13 0 0 0 1.163-1.09V11.883a1.13 1.13 0 0 0-1.163-1.077"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M14.827 9.617H8.998v13.248h5.829a1.136 1.136 0 0 0 1.163-1.09V10.706a1.137 1.137 0 0 0-1.163-1.09"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M14.827 9.617H8.998v13.18h5.829a1.13 1.13 0 0 0 1.163-1.089V10.706a1.137 1.137 0 0 0-1.163-1.09"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M14.827 9.89H8.998v13.53h5.829a1.136 1.136 0 0 0 1.163-1.09V10.967a1.13 1.13 0 0 0-1.163-1.076"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M14.827 10.145H8.998v13.529h5.829a1.13 1.13 0 0 0 1.163-1.09V11.22a1.13 1.13 0 0 0-1.163-1.076"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M15.923 9.998h-6.09a.427.427 0 0 0-.434.42v12.326a.43.43 0 0 0 .435.422h6.09a.86.86 0 0 0 .875-.843V10.84a.86.86 0 0 0-.876-.842"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M15.254 9.998H9.158a.4.4 0 0 0-.16.033v12.827q.08.015.16 0h6.096a.855.855 0 0 0 .87-.842V10.84a.857.857 0 0 0-.87-.842"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M13.723 9.269H9.285a.43.43 0 0 0-.434.421v12.326a.43.43 0 0 0 .434.42h6.096a.86.86 0 0 0 .896-.841v-11.11c0-.5-1.183-.775-1.337-.922a2.7 2.7 0 0 0-1.217-.294"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M15.608 10.606H9.54a.427.427 0 0 0-.435.421v12.326a.43.43 0 0 0 .435.42h6.07a.86.86 0 0 0 .875-.841V11.448a.86.86 0 0 0-.876-.842"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M15.088 8.855h-4.345v3.75H8.998v7.265h-.073v1.731a.43.43 0 0 0 .434.422l4.826-.876c.481 0 1.778-.408 1.778-.87V9.698a.86.86 0 0 0-.875-.842"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .15,
					d: "M15.088 9.062h-4.345v3.542H8.998v7.48h-.073v1.731a.43.43 0 0 0 .434.421l4.84-.855c.48 0 1.778-.401 1.778-.87v-10.6a.86.86 0 0 0-.89-.85"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.17 9.236h11.657a1.143 1.143 0 0 1 1.163 1.123V21.6a1.08 1.08 0 0 1-.34.79 1.2 1.2 0 0 1-.823.333H3.17a1.17 1.17 0 0 1-.822-.334A1.1 1.1 0 0 1 2 21.601V10.36a1.15 1.15 0 0 1 1.17-1.123",
			fill: "#0078d4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.356 13.875a3.6 3.6 0 0 1 1.45-1.551 4.56 4.56 0 0 1 2.313-.535 4.2 4.2 0 0 1 2.139.535 3.6 3.6 0 0 1 1.417 1.47 4.7 4.7 0 0 1 .494 2.18 4.9 4.9 0 0 1-.514 2.279 3.6 3.6 0 0 1-1.457 1.53 4.78 4.78 0 0 1-4.405 0 3.7 3.7 0 0 1-1.43-1.484 4.55 4.55 0 0 1-.502-2.152 5 5 0 0 1 .495-2.26zM6.92 17.51c.167.41.45.763.815 1.016.376.255.823.386 1.277.374.474.016.942-.117 1.337-.381.361-.254.638-.61.795-1.023.174-.454.26-.937.254-1.424a4.1 4.1 0 0 0-.24-1.443 2.26 2.26 0 0 0-.762-1.056 2.18 2.18 0 0 0-1.337-.401 2.23 2.23 0 0 0-1.304.374c-.37.255-.66.61-.835 1.023a3.96 3.96 0 0 0 0 2.94",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M5.356 13.875a3.6 3.6 0 0 1 1.45-1.551 4.56 4.56 0 0 1 2.313-.535 4.2 4.2 0 0 1 2.139.535 3.6 3.6 0 0 1 1.417 1.47 4.7 4.7 0 0 1 .494 2.18 4.9 4.9 0 0 1-.514 2.279 3.6 3.6 0 0 1-1.457 1.53 4.78 4.78 0 0 1-4.405 0 3.7 3.7 0 0 1-1.43-1.484 4.55 4.55 0 0 1-.502-2.152 5 5 0 0 1 .495-2.26zM6.92 17.51c.167.41.45.763.815 1.016.376.255.823.386 1.277.374.474.016.942-.117 1.337-.381.361-.254.638-.61.795-1.023.174-.454.26-.937.254-1.424a4.1 4.1 0 0 0-.24-1.443 2.26 2.26 0 0 0-.762-1.056 2.18 2.18 0 0 0-1.337-.401 2.23 2.23 0 0 0-1.304.374c-.37.255-.66.61-.835 1.023a3.96 3.96 0 0 0 0 2.94",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.356 13.875a3.6 3.6 0 0 1 1.45-1.551 4.56 4.56 0 0 1 2.313-.535 4.2 4.2 0 0 1 2.139.535 3.6 3.6 0 0 1 1.417 1.47 4.7 4.7 0 0 1 .494 2.18 4.9 4.9 0 0 1-.514 2.279 3.6 3.6 0 0 1-1.457 1.53 4.78 4.78 0 0 1-4.405 0 3.7 3.7 0 0 1-1.43-1.484 4.55 4.55 0 0 1-.502-2.152 5 5 0 0 1 .495-2.26zM6.92 17.51c.167.41.45.763.815 1.016.376.255.823.386 1.277.374.474.016.942-.117 1.337-.381.361-.254.638-.61.795-1.023.174-.454.26-.937.254-1.424a4.1 4.1 0 0 0-.24-1.443 2.26 2.26 0 0 0-.762-1.056 2.18 2.18 0 0 0-1.337-.401 2.23 2.23 0 0 0-1.304.374c-.37.255-.66.61-.835 1.023a3.96 3.96 0 0 0 0 2.94",
			fill: "url(#paint1_linear_9758_1684)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.356 13.875a3.6 3.6 0 0 1 1.45-1.551 4.56 4.56 0 0 1 2.313-.535 4.2 4.2 0 0 1 2.139.535 3.6 3.6 0 0 1 1.417 1.47 4.7 4.7 0 0 1 .494 2.18 4.9 4.9 0 0 1-.514 2.279 3.6 3.6 0 0 1-1.457 1.53 4.78 4.78 0 0 1-4.405 0 3.7 3.7 0 0 1-1.43-1.484 4.55 4.55 0 0 1-.502-2.152 5 5 0 0 1 .495-2.26zM6.92 17.51c.167.41.45.763.815 1.016.376.255.823.386 1.277.374.474.016.942-.117 1.337-.381.361-.254.638-.61.795-1.023.174-.454.26-.937.254-1.424a4.1 4.1 0 0 0-.24-1.443 2.26 2.26 0 0 0-.762-1.056 2.18 2.18 0 0 0-1.337-.401 2.23 2.23 0 0 0-1.304.374c-.37.255-.66.61-.835 1.023a3.96 3.96 0 0 0 0 2.94",
			fill: "url(#paint2_linear_9758_1684)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_9758_1684",
				x1: 53.809,
				y1: 63.578,
				x2: 44.973,
				y2: 73.701,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#35b8f1" }), /* @__PURE__ */ _jsx("stop", {
					offset: .75,
					stopColor: "#0d64ad"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_9758_1684",
				x1: 35.931,
				y1: 57.669,
				x2: 35.931,
				y2: 66.223,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#f2f2f2" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fff"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_9758_1684",
				x1: -71.011,
				y1: 327.295,
				x2: -71.011,
				y2: 326.42,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#f2f2f2" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fff"
				})]
			})
		] })
	]
});
export default SvgMicrosoftOutlookRegularIcon;
